/**
 * Converts NMEA / raw time strings to HH:mm:ss for 24lock pickers and comparisons.
 * Handles: 051002.319, 051002, 05:10, 05:10:02
 */
export const parseNMEATimeToDisplay = (
  time: string | null | undefined,
): string | null => {
  if (!time) return null;

  const s = String(time).trim();

  const colonMatch = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (colonMatch) {
    const hours = colonMatch[1].padStart(2, "0");
    const minutes = colonMatch[2];
    const seconds = colonMatch[3] ?? "00";
    return `${hours}:${minutes}:${seconds}`;
  }

  const nmeaMatch = s.match(/^(\d{2})(\d{2})(\d{2})(?:\.\d+)?$/);
  if (nmeaMatch) {
    return `${nmeaMatch[1]}:${nmeaMatch[2]}:${nmeaMatch[3]}`;
  }

  const shortMatch = s.match(/^(\d{2})(\d{2})$/);
  if (shortMatch) {
    return `${shortMatch[1]}:${shortMatch[2]}:00`;
  }

  return null;
};
